var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSendMax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.72277 1.01126C14.9391 0.686111 18.9849 7.46711 15.9923 12.898C14.3999 15.7889 10.8174 17.5886 7.54797 16.8023C6.80546 16.6235 6.21367 16.2221 5.58996 15.8072C5.43919 16.0089 5.24282 16.1722 5.03722 16.312C4.43406 16.7316 3.33015 17.1903 2.61047 16.9175C2.02587 16.6952 2.17231 16.067 2.12218 15.5581C1.92571 13.5935 1.09577 11.8118 1.0089 9.74173C0.810134 5.01219 3.95687 1.26115 8.72277 1.01126ZM14.4523 6.55032C13.3526 4.13328 10.9182 2.79461 8.29504 3.02786C5.70228 3.25773 3.81519 5.41403 3.25011 7.86478C2.82974 9.6666 2.91715 12.5982 3.63683 14.3189C3.86551 14.8597 4.05451 15.2005 4.6632 14.8726C5.08341 14.6393 5.4503 14.2344 5.83019 13.937V13.94C10.6561 17.2392 16.887 11.9287 14.4523 6.55032Z",
    fill: "#AFAFAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSendMax);
export default __webpack_public_path__ + "static/media/icon_send_max.011b636a6bca2a0b4cd2fcfafeac6c32.svg";
export { ForwardRef as ReactComponent };